<mat-toolbar *ngIf="remainingDaysInSubscription" color="accent" class="banner">
  <div
    class="banner__content"
    [innerHTML]="'subscriptionExpiresSoon.bannerNotice' | translate: { days: remainingDaysInSubscription }"
  ></div>
  <button (click)="onUpgradeNow()" mat-flat-button class="banner__cta">
    {{ 'general.upgradeNow' | translate }}
  </button>
</mat-toolbar>
